export default __webpack_public_path__ + "undock-logo.5fabcff8.webp";